
import { AB_TEST_CONFIGS, type PatternConfig, type AbTestConfig } from './abTestSettings'

export const getGtmPrefix = (currentPath: string, pattern: 'A' | 'B' | 'C' | 'D'): string => {

    if (pattern === 'A') return ''
    
    const activeConfig = AB_TEST_CONFIGS.find(config => 
        config.isActive && config.pathRegex.test(currentPath)
    )
    
    if (!activeConfig) return ''
    
    const hasPattern = activeConfig.patterns.some(p => p.pattern === pattern)
    if (hasPattern) {
        return `_${activeConfig.issueNumber}_${pattern}`
    }
    
    return ''
}

export const addGtmPrefix = (
    originalLabel: string, 
    currentPath: string, 
    pattern: 'A' | 'B' | 'C' | 'D'
): string => {
    const prefix = getGtmPrefix(currentPath, pattern)
    return prefix ? `${originalLabel}${prefix}` : originalLabel
}

export const isAbTestActive = (currentPath: string): boolean => {
    return AB_TEST_CONFIGS.some(config =>
        config.isActive && config.pathRegex.test(currentPath)
    )
}

export const getActiveAbTestConfig = (currentPath: string): AbTestConfig | undefined => {
    return AB_TEST_CONFIGS.find(config =>
        config.isActive && config.pathRegex.test(currentPath)
    )
}

export const validatePercentages = (patterns: PatternConfig[]): boolean => {
    const total = patterns.reduce((sum, pattern) => sum + pattern.percentage, 0)
    return total === 100
}

export const getPatternByPercentage = (abValue: number, patterns: PatternConfig[]): 'A' | 'B' | 'C' | 'D' => {
    if (!validatePercentages(patterns)) {
        const total = patterns.reduce((sum, pattern) => sum + pattern.percentage, 0)
        console.error(`ABテスト設定エラー: パーセンテージの合計が100%ではありません (現在: ${total}%)`)
        console.error('設定:', patterns)
        return patterns[0].pattern
    }

    let cumulativePercentage = 0
    const scaledValue = (abValue / 10) * 100

    for (const patternConfig of patterns) {
        cumulativePercentage += patternConfig.percentage
        if (scaledValue < cumulativePercentage) {
            return patternConfig.pattern
        }
    }

    return patterns[patterns.length - 1].pattern
}
